import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";
import useAppSelectors from "../../../../customHooks/useAppSelectors";
import { crossIcon, crossIconDiv } from "../../../../assets/commonFunction";
import {
  AccountLevelArkchatPermission,
  monthMapping,
} from "../../../../utils/constant";
const classes = {
  drawerBody: {
    minWidth: "31.25rem",
    maxWidth: "31.25rem",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    height: "100%",
  },
  header: {
    backgroundColor: "#E1E1E1",
    color: "black",
    padding: "7px 8px",
  },
  iconDiv: crossIconDiv,

  internalExternalButton: {
    background: "white",
    border: "1px solid #183243",
    color: "#183243",
    borderRadius: "0px",
    "&:hover": {
      background: "white",
    },
  },

  activeButton: {
    "&:hover": {
      background: "#183243",
    },
    background: "#183243",
    borderRadius: "0px",
    color: "white",
  },

  iconn: crossIcon,
  radiogp: {
    display: "block",
  },
  groupMember: {
    backgroundColor: "#F3F3F3",
    padding: "20px 10px",
  },

  // add group member
  addgmember: {
    transform: "translate(0, 70%)",
    textAlign: "center",
  },
  // add group member
};

const Resource = ({
  setResourceUtilisationOpen,
  selectedTaskGroup,
  selectedTaskmember,
  taskTabValue,
}) => {
  const { currentUserData } = useAppSelectors();
  const taskAnalyticsData = useSelector(
    (state) => state?.arkchatgroup?.taskAnalyticsData
  );
  return (
    <React.Fragment>
      <Box sx={classes.drawerBody}>
        <Stack>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={classes.header}
          >
            <Stack direction="row" alignItems="center" spacing={2}>
              <Typography sx={classes.iconDiv}>
                <CloseIcon
                  sx={classes.iconn}
                  onClick={() => setResourceUtilisationOpen(false)}
                />
              </Typography>
              <Typography variant="subtitle2">
                {currentUserData?.activePermission ===
                AccountLevelArkchatPermission?.ADMIN ? (
                  <>
                    {selectedTaskGroup?.length > 0
                      ? `${selectedTaskGroup[0]?.name}`
                      : selectedTaskmember?.length
                      ? `${selectedTaskmember[0]?.userInfo?.firstName} ${selectedTaskmember[0]?.userInfo?.lastName}`
                      : taskTabValue === 1
                      ? `${currentUserData?.firstName} ${currentUserData?.lastName}`
                      : "Group"}
                  </>
                ) : (
                  <>{`${currentUserData?.firstName} ${currentUserData?.lastName}`}</>
                )}
              </Typography>
            </Stack>
          </Stack>
          <Stack
            width={"95%"}
            margin={"auto"}
            mt={"0.5rem"}
            overflow={"scroll"}
            overflowY={"hidden"}
            height={"calc(100vh - 6rem)"}
            sx={{
              "&::-webkit-scrollbar": {
                width: "2px",
                padding: "0px 2px",
              },
              "&::-webkit-scrollbar-track": {
                background: "#F9F8F8",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "grey",
              },
            }}
          >
            {taskAnalyticsData?.groupData?.map((groupAnalyticsData) => (
              <>
                {groupAnalyticsData?.months?.length > 0 && (
                  <Box
                    boxShadow={" 0px 1.52px 6.08px 0px #00000040"}
                    key={groupAnalyticsData?.id + "groupAnalyticsData"}
                    width={"90%"}
                    margin={"auto"}
                    padding={"0.6rem"}
                    mt={"0.8rem"}
                    borderRadius={"0.25rem"}
                  >
                    <Box mb={"1rem"} textAlign={"center"}>
                      <Typography
                        fontWeight={"600"}
                        variant="h4"
                        fontSize={"0.85rem"}
                      >
                        Timesheet (Hours)
                      </Typography>
                      <Typography
                        fontWeight={"600"}
                        mt={"0.5rem"}
                        variant="h4"
                        fontSize={"0.85rem"}
                      >
                        {groupAnalyticsData?.name}
                      </Typography>
                    </Box>

                    {groupAnalyticsData?.months.map((monthData, i) => (
                      <Box
                        key={groupAnalyticsData?.id + "monthData" + i}
                        display={"flex"}
                        justifyContent={"space-between"}
                        gap={"1rem"}
                        mb={"0.5rem"}
                      >
                        <Box
                          display={"flex"}
                          alignItems={"center"}
                          width={"35%"}
                        >
                          <Typography variant="h4" fontSize={"0.85rem"}>
                            {monthMapping[monthData?.month]} {monthData?.year}
                          </Typography>
                        </Box>
                        <Box width={"64%"}>
                          <Box
                            bgcolor={"#007F8F"}
                            width={`${
                              Math.floor((monthData?.analysis_time?.timeValue / monthData?.max_time.timeValue) * 100) || 8
                            }%`}
                            display={"flex"}
                            alignItems={"center"}
                            textAlign={"end"}
                          >
                            <Typography
                              color={"#fff"}
                              width={"100%"}
                              fontSize={"0.85rem"}
                              fontWeight={"600"}
                              mr={"0.4rem"}
                            >
                              {Math.floor(monthData?.analysis_time?.timeValue)}
                            </Typography>
                            {/* <Typography fontSize={"0.85rem"} fontWeight={"600"}>
                          {monthData?.analysis_time?.timeType}
                        </Typography> */}
                          </Box>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                )}
              </>
            ))}
          </Stack>
        </Stack>
      </Box>
    </React.Fragment>
  );
};

export default Resource;
